import React, { useEffect, useState } from 'react';
import { Card, Col, FormInstance, Row, Select } from 'antd';
import { useQuery } from '@apollo/client';
import { queries } from '../../../graphql/graphql';
import { Loader } from '../../UI/Loader';
import { IContractor } from '../../../types/contractor';

export const SelectContractor = ({
  form,
  onChange,
}: {
  form: FormInstance;
  onChange?: (value: string) => void;
}) => {
  const [contractor, setContractor] = useState<IContractor | null>(null);
  const { data: contractors, loading } = useQuery(queries.contractors.CONTRACTORS);
  const value = form.getFieldValue('contractorId');

  useEffect(() => {
    if (contractors?.contractors && value) {
      setContractor(contractors.contractors.find((c: IContractor) => c.id === value));
    }
  }, [contractors, value]);

  const contractorsOptions = contractors?.contractors.map((contractor: IContractor) => ({
    label: contractor.name,
    value: contractor.id,
  }));

  const handleChange = (value: string) => {
    if (contractors?.contractors) {
      setContractor(contractors.contractors.find((c: IContractor) => c.id === value));
    }
    onChange?.(value);
  };

  if (loading) return <Loader />;

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <Select options={contractorsOptions} value={value} onChange={handleChange} />
      </Col>
      {contractor && (
        <Col span={24}>
          <Card>
            <Card.Meta title={contractor.name} description={contractor.ceo} />
          </Card>
        </Col>
      )}
    </Row>
  );
};
